import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreAlarmLogsReportWizardMetaData',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  props: {
    reportModel: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      markdownEdit: false,
      editModel: null,
      accounts: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    reportTypes: function reportTypes() {
      return [{
        name: this.$i18n_t('AlarmLogs.reports.wizard.reportTypes.device'),
        id: 'virtual-device--health-state'
      }, {
        name: this.$i18n_t('AlarmLogs.reports.wizard.reportTypes.packetMonitoring'),
        id: 'smartgroup-packet-monitoring'
      }];
    }
  }),
  watch: {
    reportModel: {
      handler: function handler() {
        this.editModel = cloneDeep(this.reportModel);
      },
      deep: true,
      immediate: true
    },
    editModel: {
      handler: function handler() {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.reportModel)) {
          this.publishChanges();
        }
      },
      deep: true
    },
    'editModel.filters.originType': function editModelFiltersOriginType() {
      if (this.editModel.filters.originType === 'smartgroup-packet-monitoring') {
        this.editModel.filters.categories = ['packet-threshold'];
      }
    }
  },
  created: function created() {
    this.fetchAccounts();
  },
  methods: {
    fetchAccounts: function fetchAccounts() {
      var _this2 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        // filter the root-tenant, because that one does not have a twin to attach the new device to
        _this2.accounts = accounts.filter(function (t) {
          return !t.isRootTenant;
        });
      }).catch(function (error) {
        console.error(error);

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};